module.exports = __webpack_public_path__ + "img/31ec7df.jpg";